import { Navigate, useLocation, useNavigate, useRoutes } from 'react-router-dom'
import { _bootstrap }                  from 'state/store.bootstrap'
import { useAtom, useFocusGet }                 from 'state/jotai'

import { Root }                                     from 'pages/View.Root'
import { standard } from 'pages/Views.constants'

import { current_language } from 'state/store.global'
import { useEffect } from 'react'

export const useBuildRoutes = () => {

 
  const start    = useFocusGet(_bootstrap, 'startpage')
    const [language, setCurrent_language] = useAtom(current_language);
      const navigate        = useNavigate();
        const location1       = useLocation().pathname.split("/")[1];
      
        useEffect(() => {
          if(location1) {
          setCurrent_language(location1)
          }
        }, [location1])
  return [
        {
          path: '/',
          element: <Root />,
          children: [
            { path: '', element: <Navigate to={start} replace />, index: true },
            ... standard(language,start),
            { path: '*', element: <Navigate to={start} replace />, index: true  },
          ],
        },
      ]
}

export const Views = () => useRoutes( useBuildRoutes() )